module.exports = __webpack_public_path__ + "img/device_car_off.5a198abe.svg";